<template>
    <el-main>
        <el-tabs v-model="activeName">
            <el-tab-pane v-for="item in tabList" :key="item.step" :label="item.name" :name="item.step"></el-tab-pane>
        </el-tabs>
        <!-- 展示需要收集的数据 -->
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
            <div v-if="activeName == 'first'">
                <el-form-item label="提现设置"></el-form-item>
                <el-form-item label="最低提现金额" prop="">
                    <el-input v-model="ruleForm.minimum_withdrawal_amount"></el-input>
                </el-form-item>
                <el-form-item label="结算说明"></el-form-item>
                <el-form-item label="结算说明" prop="">
                    <RichText :richTxt="ruleForm.withdrawal_explain"
                        @soninfo="val => (ruleForm.withdrawal_explain = val)">
                    </RichText>
                </el-form-item>
            </div>
            <div v-if="activeName == 'second'">
                <el-form-item label="微信小程序AppID" prop="">
                    <el-input v-model="ruleForm.store_appid_set.app_id"></el-input>
                </el-form-item>
                <el-form-item label="秘钥" prop="">
                    <el-input v-model="ruleForm.store_appid_set.secret"></el-input>
                </el-form-item>
            </div>
            <div v-if="activeName == 'third'">
                <el-form-item label="微信小程序AppID" prop="">
                    <el-input v-model="ruleForm.wifi_appid_set.app_id"></el-input>
                </el-form-item>
                <el-form-item label="秘钥" prop="">
                    <el-input v-model="ruleForm.wifi_appid_set.secret"></el-input>
                </el-form-item>
                <el-form-item label="跳转路径" prop="">
                    <el-input v-model="ruleForm.wifi_appid_set.path"></el-input>
                </el-form-item>
                <el-form-item label="原始ID" prop="">
                    <el-input v-model="ruleForm.wifi_appid_set.original_id"></el-input>
                </el-form-item>
            </div>
            <div v-if="activeName == 'fourth'">
                <el-form-item label="微信小程序AppID" prop="">
                    <el-input v-model="ruleForm.scan_code_set.app_id"></el-input>
                </el-form-item>
                <el-form-item label="秘钥" prop="">
                    <el-input v-model="ruleForm.scan_code_set.secret"></el-input>
                </el-form-item>
                <el-form-item label="商户号Mch_ID" prop="">
                    <el-input v-model="ruleForm.scan_code_set.m_id"></el-input>
                </el-form-item>
                <el-form-item label="支付秘钥APIkey" prop="">
                    <el-input v-model="ruleForm.scan_code_set.api_key"></el-input>
                </el-form-item>
                <el-form-item label="跳转路径" prop="">
                    <el-input v-model="ruleForm.scan_code_set.path"></el-input>
                </el-form-item>
                <el-form-item label="原始ID" prop="">
                    <el-input v-model="ruleForm.scan_code_set.original_id"></el-input>
                </el-form-item>
                <el-form-item label="apiclient_cert">
                    <div class="upBox">
                        <el-input placeholder="请上传apiclient_key证书" disabled
                            v-model="ruleForm.scan_code_set.apiclient_cert">
                        </el-input>
                        <div class="uploadFile">
                            <el-button type="primary">上传文件</el-button>
                            <input type="file" ref="inputer0" accept=".pem" @change="getFile(0)" />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="apiclient_key">
                    <div class="upBox">
                        <el-input placeholder="请上传apiclient_key证书" disabled
                            v-model="ruleForm.scan_code_set.apiclient_key">
                        </el-input>
                        <div class="uploadFile">
                            <el-button type="primary">上传文件</el-button>
                            <input type="file" ref="inputer1" accept=".pem" @change="getFile(1)" />
                        </div>
                    </div>
                </el-form-item>
            </div>
            <div v-if="activeName == 'fifth'">
                <el-form-item label="WIFI连接设置"></el-form-item>
                <el-form-item label="连接有效天数:" prop="">
                    <el-input v-model="ruleForm.link_valid_day">
                        <template slot="append">天</template>
                    </el-input>
                    <span class="tips">用户在N天内多次连接wifi仅算1次有效</span>
                </el-form-item>
                <el-form-item label="单次连接佣金:" prop="">
                    <el-input v-model="ruleForm.single_link_price">
                        <template slot="append">元</template>
                    </el-input>
                    <span class="tips">用户有效连接1次，给出的总佣金数</span>
                </el-form-item>
                <el-form-item label="其他奖励设置"></el-form-item>
                <el-form-item label="扫码点餐佣金:" prop="">
                    <el-input v-model="ruleForm.scan_code_price">
                        <template slot="append">元</template>
                    </el-input>
                    <span class="tips">用户产生1笔有效订单，所支付总佣金</span>
                </el-form-item>
                <el-form-item label="扫码点餐佣金起算金额:" prop="">
                    <el-input v-model="ruleForm.single_scan_price">
                        <template slot="append">元</template>
                    </el-input>
                    <span class="tips">超过扫码点餐佣金起算金额的订单，才会产生点餐佣金</span>
                </el-form-item>
                <el-form-item label="用户红包收益:" prop="">
                    <el-input style="width:190px" v-model="ruleForm.red_mix_price">
                        <template slot="append">元</template>
                    </el-input>
                    ~
                    <el-input style="width:190px" v-model="ruleForm.red_max_price">
                        <template slot="append">元</template>
                    </el-input>
                    <span class="tips">用户进入可以领红包金额区间，产生随机金额</span>
                </el-form-item>
                <el-form-item label="消费奖励政策:">运营商、发展商、商家都有奖励</el-form-item>
                <el-form-item label="每笔有效消费奖励:" prop="">
                    <el-input v-model="ruleForm.vail_pay_incentive">
                        <template slot="append">元</template>
                    </el-input>
                    <span class="tips">用户产生1笔有效订单,所奖励的总佣金</span>
                </el-form-item>
                <el-form-item label="奖励有效期限:" prop="">
                    <el-date-picker style="width:190px" v-model="ruleForm.vail_pay_start_time" type="date"
                        placeholder="选择开始日期">
                    </el-date-picker>
                    ~
                    <el-date-picker style="width:190px" v-model="ruleForm.vail_pay_end_time" type="date"
                        placeholder="选择结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="连接奖励政策:">运营商专享奖励</el-form-item>
                <el-form-item label="有效连接次数达到:" prop="">
                    <el-input style="width:190px" v-model="ruleForm.vail_connect_times">
                        <template slot="append">次/码</template>
                    </el-input>
                    奖励运营商
                    <el-input style="width:190px" v-model="ruleForm.vail_connect_price">
                        <template slot="append">元/码</template>
                    </el-input>
                    <span class="tips">用户产生1笔有效订单算1次,连接wifi成功算一次</span>
                </el-form-item>
                <el-form-item label="奖励有效期限:" prop="">
                    <el-date-picker style="width:190px" v-model="ruleForm.vail_connect_start_time" type="date"
                        placeholder="选择开始日期">
                    </el-date-picker>
                    ~
                    <el-date-picker style="width:190px" v-model="ruleForm.vail_connect_end_time" type="date"
                        placeholder="选择结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="限制连续wifi时长:" prop="">
                    <el-input v-model="ruleForm.limit_user_link_wifi_time">
                        <template slot="append">分钟</template>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <Preservation @preservation="Preservation"></Preservation>
    </el-main>
</template>

<script>
import Preservation from '@/components/preservation'
import RichText from '@/components/richText';
import _ from 'lodash'
export default {
    components: {
        Preservation,
        RichText
    },
    data () {
        return {
            activeName: 'fifth',
            tabList: [
                { name: '基础设置', step: 'first' },
                { name: '门店助手小程序', step: 'second' },
                { name: 'wifi小程序', step: 'third' },
                { name: '扫码点餐小程序', step: 'fourth' },
                { name: '奖励设置', step: 'fifth' },
            ],
            ruleForm: {
                minimum_withdrawal_amount: '',
                withdrawal_explain: '',
                store_appid_set: {
                    app_id: '',
                    secret: ''
                },
                wifi_appid_set: {
                    app_id: '',
                    secret: '',
                    path: '',
                    original_id: ''
                },
                scan_code_set: {
                    app_id: '',
                    m_id: '',
                    secret: '',
                    apiclient_cert: '',
                    apiclient_key: '',
                    path: '',
                    original_id: ''
                },
                link_valid_day: '',
                single_link_price: '',
                scan_code_price: '',
                single_scan_price: '',
                red_mix_price: '',
                red_max_price: '',
                vail_pay_incentive: '',
                vail_pay_start_time: null,
                vail_pay_end_time: null,
                vail_connect_times: '',
                vail_connect_price: '',
                vail_connect_start_time: null,
                vail_connect_end_time: null,
                limit_user_link_wifi_time: ''
            },
            rules: {}
        }
    },
    created () {
        this.getSet()
    },
    methods: {
        // 获取设置
        getSet () {
            this.$axios.post(this.$api.set.TwitterSetInfo).then(res => {
                if (res.code === 0) {
                    this.ruleForm.minimum_withdrawal_amount = res.result.minimum_withdrawal_amount
                    this.ruleForm.withdrawal_explain = res.result.withdrawal_explain
                    this.ruleForm.store_appid_set = res.result.store_appid_sets
                    this.ruleForm.wifi_appid_set = res.result.wifi_appid_sets
                    this.ruleForm.scan_code_set = res.result.scan_code_sets
                    this.ruleForm.link_valid_day = res.result.link_valid_day
                    this.ruleForm.single_link_price = res.result.single_link_price
                    this.ruleForm.scan_code_price = res.result.scan_code_price
                    this.ruleForm.single_scan_price = res.result.single_scan_price
                    this.ruleForm.red_mix_price = res.result.red_mix_price
                    this.ruleForm.red_max_price = res.result.red_max_price
                    this.ruleForm.limit_user_link_wifi_time = res.result.limit_user_link_wifi_time
                    //
                    this.ruleForm.vail_pay_incentive = res.result.vail_pay_incentive
                    this.ruleForm.vail_pay_start_time = res.result.vail_pay_start_time ? res.result.vail_pay_start_time * 1000 : null
                    this.ruleForm.vail_pay_end_time = res.result.vail_pay_end_time ? res.result.vail_pay_end_time * 1000 : null
                    this.ruleForm.vail_connect_times = res.result.vail_connect_times
                    this.ruleForm.vail_connect_price = res.result.vail_connect_price
                    this.ruleForm.vail_connect_start_time = res.result.vail_connect_start_time ? res.result.vail_connect_start_time * 1000 : null
                    this.ruleForm.vail_connect_end_time = res.result.vail_connect_end_time ? res.result.vail_connect_end_time * 1000 : null

                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        // 上传文件
        getFile (status) {
            let files = null
            let that = this
            if (status == 0) {
                files = this.$refs.inputer0.files[0]
            } else if (status == 1) {
                files = this.$refs.inputer1.files[0]
            }
            let formData = new FormData()
            formData.append('cert', files)
            this.$axios.uploadFile(this.$api.upload.addCert, formData).then((res) => {
                if (res.code == 0) {
                    that.$message.success('上传成功')
                    if (status == 0) {
                        this.ruleForm.scan_code_set.apiclient_cert = res.result.path
                        this.$refs.inputer0.files[0].value = ''
                    } else {
                        this.ruleForm.scan_code_set.apiclient_key = res.result.path
                        this.$refs.inputer1.files[0].value = ''
                    }
                } else {
                    that.$message.error(`${res.msg}`)
                }
            })
        },
        // 点击保存
        Preservation () {
            if (!this.checkData()) {
                this.$message.warning('请检查各个选项的数据是否填写完整')
                return
            }
            let obj = _.cloneDeep(this.ruleForm)
            obj.vail_pay_start_time = Math.floor(obj.vail_pay_start_time / 1000)
            obj.vail_pay_end_time = Math.floor(obj.vail_pay_end_time / 1000)
            obj.vail_connect_start_time = Math.floor(obj.vail_connect_start_time / 1000)
            obj.vail_connect_end_time = Math.floor(obj.vail_connect_end_time / 1000)
            this.$axios.post(this.$api.set.TwitterSet, obj).then(res => {
                if (res.code == 0) {
                    this.$message.success('设置成功')
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        // 保存前校验数据
        checkData () {
            let flag = true
            for (const key in this.ruleForm) {
                if (this.ruleForm[key] === '') {
                    flag = false
                    break
                }
                if (typeof this.ruleForm[key] === 'object') {
                    let sonFlag = true
                    for (const son in this.ruleForm[key]) {
                        if (this.ruleForm[key][son] === '') {
                            sonFlag = false
                            break
                        }
                    }
                    flag = sonFlag
                }
            }
            return flag
        }
    }
}
</script>

<style lang="less" scoped>
.el-main {
    background-color: #fff;
    min-height: 100%;
    padding-bottom: 80px;

    .tips {
        font-size: 12px;
        color: #999;
        font-weight: 400;
        margin-left: 20px;
    }

    .el-input {
        width: 400px;
    }

    .uploadFile {
        position: relative;
        color: #1467ff;
        cursor: pointer;

        &>input {
            opacity: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            right: 0;
        }
    }

    .upBox {
        display: flex;
        align-items: center;
    }

}
</style>